module.exports = __webpack_public_path__ + "static/media/f01_1.29e27352.png";